import {appAPI} from "../../../api";
import {IDrivingEvent} from "../../../models/IDrivingEvent";

const basePath = `/aggressive-driving-events`;

interface GetRecentQuery {
    limit?: number;
    includeHeartbeats?: boolean;
}

export const drivingEventsAPI = {
    /** Последние N значимых событий компании (история до захода; дальше — WS). */
    getRecent: async (
        company_id: string,
        {limit = 100, includeHeartbeats = false}: GetRecentQuery = {},
    ): Promise<IDrivingEvent[]> => {
        const res = await appAPI.get(`${basePath}/company/${company_id}/recent`, {
            params: {limit, includeHeartbeats},
        });
        // Сервер может вернуть массив или {items} — поддержим оба (как в invoices).
        return Array.isArray(res.data) ? res.data : (res.data.items ?? []);
    },
};